import {parseISO} from "date-fns";

import {TrendSeriesPoint} from "../types/TrendSeriesPoint";

export interface ISeriesTrend {
    pointsCount: number;
    firstDate: string;
    lastDate: string;
    startValue: number;
    endValue: number;
    changePct: number;
    valueAt: (timestamp: number) => number;
}

const MIN_POINTS_FOR_TREND = 2;

// parseISO, like the chart that places the points: `new Date("2022-12-01")` is UTC midnight while parseISO reads local
// midnight, and a line fitted on one clock but read on the other misjudges which side of it a point lies on.
const toTimestamp = (date: string) => parseISO(date).getTime();

export const getSeriesTrend = (points: TrendSeriesPoint[]): ISeriesTrend | null => {
    if (points.length < MIN_POINTS_FOR_TREND) {
        return null;
    }

    const sorted = [...points].sort((a, b) => toTimestamp(a.date) - toTimestamp(b.date));
    const xs = sorted.map((point) => toTimestamp(point.date));
    const ys = sorted.map((point) => point.value);

    const meanX = xs.reduce((sum, x) => sum + x, 0) / xs.length;
    const meanY = ys.reduce((sum, y) => sum + y, 0) / ys.length;

    const variance = xs.reduce((sum, x) => sum + (x - meanX) ** 2, 0);
    const covariance = xs.reduce((sum, x, index) => sum + (x - meanX) * (ys[index] - meanY), 0);

    const slope = variance === 0 ? 0 : covariance / variance;

    const valueAt = (timestamp: number) => meanY + slope * (timestamp - meanX);

    const startValue = valueAt(xs[0]);
    const endValue = valueAt(xs[xs.length - 1]);

    return {
        pointsCount: sorted.length,
        firstDate: sorted[0].date,
        lastDate: sorted[sorted.length - 1].date,
        startValue,
        endValue,
        changePct: startValue === 0 ? 0 : Math.round(((endValue - startValue) / startValue) * 1000) / 10,
        valueAt
    };
};
import {parseISO} from "date-fns";

import {TrendSeriesPoint} from "../types/TrendSeriesPoint";

export interface ISeriesTrend {
    pointsCount: number;
    firstDate: string;
    lastDate: string;
    startValue: number;
    endValue: number;
    changePct: number;
    valueAt: (timestamp: number) => number;
}

const MIN_POINTS_FOR_TREND = 2;

// parseISO, like the chart that places the points: `new Date("2022-12-01")` is UTC midnight while parseISO reads local
// midnight, and a line fitted on one clock but read on the other misjudges which side of it a point lies on.
const toTimestamp = (date: string) => parseISO(date).getTime();

export const getSeriesTrend = (points: TrendSeriesPoint[]): ISeriesTrend | null => {
    if (points.length < MIN_POINTS_FOR_TREND) {
        return null;
    }

    const sorted = [...points].sort((a, b) => toTimestamp(a.date) - toTimestamp(b.date));
    const xs = sorted.map((point) => toTimestamp(point.date));
    const ys = sorted.map((point) => point.value);

    const meanX = xs.reduce((sum, x) => sum + x, 0) / xs.length;
    const meanY = ys.reduce((sum, y) => sum + y, 0) / ys.length;

    const variance = xs.reduce((sum, x) => sum + (x - meanX) ** 2, 0);
    const covariance = xs.reduce((sum, x, index) => sum + (x - meanX) * (ys[index] - meanY), 0);

    const slope = variance === 0 ? 0 : covariance / variance;

    const valueAt = (timestamp: number) => meanY + slope * (timestamp - meanX);

    const startValue = valueAt(xs[0]);
    const endValue = valueAt(xs[xs.length - 1]);

    return {
        pointsCount: sorted.length,
        firstDate: sorted[0].date,
        lastDate: sorted[sorted.length - 1].date,
        startValue,
        endValue,
        changePct: startValue === 0 ? 0 : Math.round(((endValue - startValue) / startValue) * 1000) / 10,
        valueAt
    };
};
